export default "__VITE_ASSET__Ccn6_KRv__"